import { render, staticRenderFns } from "./BINCardDescription.vue?vue&type=template&id=4851ab98&lang=pug&"
import script from "./BINCardDescription.vue?vue&type=script&lang=js&"
export * from "./BINCardDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports